var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconColour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215,165l37-21.7l-45.4-78.6l-35.6,20.6l21.5-36.6L114.4,3.1L93,38.5V0H0v202.8v12.9 c4,22,22.1,40.3,45.2,40.3H256v-91H215z M201.4,85.1l30.5,52.8l-46.4,27H93v-17L201.4,85.1z M92,67.5l27.1-44.1L172,54.2 l-27.5,46.4L92,130.8V67.5z M16,15h62v47.9l0,0.7l0,0.7V165H48.4c-0.9,0-1.6-0.3-2.5-0.3c-11.1,0-21.9,4-29.9,11.4V15z M242,241 H78.9H45.7c-16.8,0-30.4-13.7-30.4-30.5c0-16.8,13.6-30.5,30.4-30.5H242V241z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 210.3,
    r: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColour);
export default __webpack_public_path__ + "static/media/icon-colour.791c2890.svg";
export { ForwardRef as ReactComponent };